import { createFileRoute, notFound } from '@tanstack/react-router';

// eslint-disable-next-line no-restricted-imports -- S17: porta route leve, sem fixtures no JS inicial.
import { loadReconciliationMessages } from '@/modules/reconciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/dev/conciliacao/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  loader: loadReconciliationMessages,
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'ReconciliationDevPage') : () => null,
});
